import turfBbox from "@turf/bbox"
import turfBooleanWithin from "@turf/boolean-within"
import turfBuffer from "@turf/buffer"
import { point as turfPoint } from "@turf/helpers"

import { swedenGeoPolygonFeature } from "./geo"

export function parseLocationTrackerLatLng(locationTrackerLatLng) {
  const coordinates = (locationTrackerLatLng || ``)
    .split(`,`)
    .map((coordinate) => parseFloat(coordinate.trim()))

  if (
    coordinates.length !== 2 ||
    coordinates.some((coordinate) => Number.isNaN(coordinate))
  ) {
    return null
  }

  const [lat, lng] = coordinates

  return { lat, lng }
}

export function resolveExploreBounds(locationTrackerLatLng) {
  const parsedCoordinates = parseLocationTrackerLatLng(locationTrackerLatLng)

  if (!parsedCoordinates) {
    return {
      bounds: null,
      coordinates: null,
      reason: `missing`,
      willAddBounds: false,
    }
  }

  const coordinates = [parsedCoordinates.lng, parsedCoordinates.lat]
  const point = turfPoint(coordinates)

  if (!turfBooleanWithin(point, swedenGeoPolygonFeature)) {
    return {
      bounds: null,
      coordinates,
      reason: `outside_sweden`,
      willAddBounds: false,
    }
  }

  return {
    bounds: turfBbox(turfBuffer(point, 20, { steps: 1 })).join(`,`),
    coordinates,
    reason: `ok`,
    willAddBounds: true,
  }
}
